import * as React from 'react';
import '@/pages/customer_service/components/BottomDialog/index.css';

type PropsFunc = (...args: any[]) => any;
interface IProps {
  visible: boolean;
  onMaskClick?: PropsFunc;
  onOK?: PropsFunc;
  btnText?: string | React.ReactNode;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
}
export default class BottomDialog extends React.PureComponent<IProps, any> {
  onMaskClick = () => {
    const { onMaskClick } = this.props;
    onMaskClick && onMaskClick();
  };
  onOK = () => {
    const { onOK } = this.props;
    onOK && onOK();
  };
  render() {
    const {
      title, content, btnText, visible
    } = this.props;
    if (visible) {
      return (
        <modal>
          <view className="bottom-dialog-mask" onClick={this.onMaskClick}>
            <view
              className="bottom-dialog-content content-animation"
            >
              <view className="content">
                <view className="content-top">
                  {/*// ----- mpweb适配origin -----*/}
                  {/*{typeof (title) === 'string' ? <text content={title} className="title" /> : btnText }*/}
                  {/*// ----- mpweb适配change -----*/}
                  {typeof (title) === 'string' ? <text content={title} className="title" /> : null }
                  {/*// ----- mpweb适配       -----*/}
                  {typeof (content) === 'string' ? <text content={content} className="desc" /> : content }
                </view>
                {!!btnText && (
                  <view className="content-bottom">
                    {typeof (btnText) === 'string' ? <text content={btnText} className="primary-btn" onClick={this.onOK} /> : btnText }
                  </view>
                )}
              </view>
            </view>
          </view>
        </modal>
      );
    } else {
      return null;
    }
  }
}
